import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Drawer } from 'ksnm-common-ui/lib/Drawer';

import { Row } from '@common/Row';
import { dataControlStore } from '@stores/dataControlStore';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';
import { periodsStore } from '@stores/dictionaryStores/periodsStore';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

import styles from './InfoDrawer.module.scss';

export const InfoDrawer = observer(() => {
  const { infoDrawer, setInfoDrawer, filters } = dataControlStore;
  const { periods } = periodsStore;
  const { reportGroups } = reportGroupsStore;
  const { organizations } = organizationsStore;

  const packageFilter = filters.generalReport || {};
  const { packageCode, controlDescription, step, stepName, stepDescription, control, ctrlName, formula, ksCodeFns } =
    infoDrawer || {};

  const onClose = useCallback(() => {
    setInfoDrawer(null);
  }, [setInfoDrawer]);

  const organization = organizations.find((item) => item.code === packageFilter.organization);

  const year = packageCode?.substring(packageCode?.lastIndexOf('Y') + 1, packageCode?.lastIndexOf('P'));

  const group = packageCode?.substring(packageCode?.lastIndexOf('_') + 1, packageCode?.lastIndexOf('Y'));
  const reportGroup = reportGroups?.find((item) => item.code === group);

  const periodCode = packageCode?.substring(packageCode?.lastIndexOf('P') + 1, packageCode?.lastIndexOf('V'));
  const period = periods.find((item) => item.code === periodCode)?.name;

  const correct = packageCode?.substr(packageCode?.lastIndexOf('V') + 1);

  return (
    <Drawer open={!!infoDrawer} onClose={onClose} resizable title="Дополнительные параметры" zIndex={1015}>
      <>
        <Row name="Код пакета" value={infoDrawer?.packageCode} className={styles.row} />
        <Row
          name="Код организации"
          value={organization ? `${organization.code} - ${organization.name}` : ''}
          className={styles.row}
        />
        <Row
          name="Группа отчетности"
          value={reportGroup ? `${reportGroup.code} - ${reportGroup.name}` : ''}
          className={styles.row}
        />
        <Row name="Год" value={year} className={styles.row} />
        <Row name="Период" value={`${periodCode} - ${period}`} className={styles.row} />
        <Row name="Номер корректировки" value={correct} className={styles.row} />
        {control && <Row name="Контроль" value={control} className={cm(styles.row, styles.topMargin)} />}
        {ctrlName && <Row name="Наименование контроля" value={ctrlName} className={styles.row} />}
        {controlDescription && <Row name="Описание контроля" value={controlDescription} className={styles.row} />}
        {step && <Row name="Номер шага" value={step} className={styles.row} />}
        {ksCodeFns && <Row name="Код контроля (ФНС)" value={ksCodeFns} className={styles.row} />}
        {stepName && <Row name="Наименование шага" value={stepName} className={styles.row} />}
        {stepDescription && <Row name="Описание шага" value={stepDescription} className={styles.row} />}
        {formula && <Row name="Формула" value={formula} className={styles.row} />}
      </>
    </Drawer>
  );
});
